let ch_pass = '1be9b66a123cff8fc91cd0a3f7092dae';
let h_pass = getCookie('setPass');
if (ch_pass === h_pass) {
    document.querySelector('.section-popup-security').style.display = "none";
} else {
    document.querySelector('.section-popup-security .popup-wrapper').style.display = "block";
}

let pform = document.querySelector('.section-popup-security #pass-protect');
if (pform) {
    pform.querySelector('button.btn-typeOk').addEventListener('click',function(){
        pform.querySelector('.error').style.display = "none";
        let pass = pform.querySelector('input[name="password"]').value;
        let hash = md5(pass);
        if (hash === ch_pass) {
            document.querySelector('.section-popup-security').style.display = "none";
            setCookie('setPass',hash,1);
        } else {
            pform.querySelector('.error').style.display = "block";
        }
    });
    pform.querySelector('button.btn-typeCancel').addEventListener('click',function(){
        window.location.href = window.location.origin;
    });
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}